import { useMenuTabsLang } from './useMenuTabsLang';

export function useMenuTabs() {
  const lang = useMenuTabsLang();
  return {
    lang,
  };
}
